import { CSS } from "@dnd-kit/utilities";
import { useSortable } from "@dnd-kit/sortable";
import { DeleteRedIcon, DragIcon, EditIcon } from "../../../assets/icons";
import { CategorySettingsItemDto } from "../../../models/categories/categories.response";

type SortableRowProps = {
  category: CategorySettingsItemDto;
  onEdit: (id: string) => void;
  onDelete: (id: string) => void;
};

const SortableCategoryRow: React.FC<SortableRowProps> = ({ category, onEdit, onDelete }) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: category.id,
  });

  const style: React.CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.85 : 1,
  };

  return (
    <div ref={setNodeRef} style={style} className="list-row-div">
      <img
        id="w-node-_784b75b9-7580-94fe-59b3-83eda50769e7-1cee91cf"
        loading="lazy"
        alt=""
        src={DragIcon}
        className="image-4"
        style={{ cursor: "grab" }}
        {...attributes}
        {...listeners}
      />

      <div>{category.name}</div>
      <div>{category.slug}</div>

      {!category.isDeleted ? (
        <div className="small-box-div green-bg">
          <div className="category-list-div-row-status">Aktivna</div>
        </div>
      ) : (
        <div className="small-box-div grey-bg">
          <div className="category-list-div-row-status">Neaktivna</div>
        </div>
      )}

      <div
        id="w-node-_784b75b9-7580-94fe-59b3-83eda50769ef-1cee91cf"
        className="table-row-action-btns-div"
      >
        <img
          loading="lazy"
          src={EditIcon}
          alt=""
          className="category-list-div-row-actions-image"
          onClick={() => onEdit(category.id)}
        />
        <img
          loading="lazy"
          src={DeleteRedIcon}
          alt=""
          className="category-list-div-row-actions-image"
          onClick={() => onDelete(category.id)}
        />
      </div>
    </div>
  );
};
export default SortableCategoryRow;